import { type RefObject, type FC } from 'react';

import { type ContinueButtonTypes } from '@core/blocks/edu-flow/components/Page/types';

import PopupButton, { PopupButtonProps } from './PopupButton';
import SubmitButton from './SubmitButton';

type DefaultProps = {
  type?: ContinueButtonTypes;
  text?: string;
  disabled?: boolean | undefined;
  onClick?: () => void;
  buttonRef?: RefObject<HTMLButtonElement>;
};

export type ContinueButtonProps = DefaultProps & PopupButtonProps;

export type ContinueButton<T = unknown> = FC<ContinueButtonProps & T>;

const continueButtonsTypeDictionary: Record<ContinueButtonTypes, ContinueButton> = {
  popupButton: PopupButton,
  defaultButton: SubmitButton,
};

export default continueButtonsTypeDictionary;
